function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.00038 4.95808C3.00038 3.87666 3.87705 3 4.95846 3H22.2489C23.3303 3 24.2069 3.87666 24.2069 4.95808V15.3323C24.2069 16.4137 23.3303 17.2904 22.2489 17.2904H4.95846C3.87705 17.2904 3.00038 16.4137 3.00038 15.3323V9.17637L12.3317 13.1755C13.1439 13.5236 14.0634 13.5236 14.8756 13.1755L20.2462 10.8738C21.0076 10.5475 21.3604 9.66569 21.034 8.90424C20.7077 8.1428 19.8259 7.79007 19.0644 8.1164L13.6939 10.4181C13.6363 10.4428 13.5711 10.4428 13.5134 10.4181L3.00038 5.91247V4.95808ZM0.000384623 6.86699V4.95808C0.000384623 2.21981 2.22019 0 4.95846 0H22.2489C24.9871 0 27.2069 2.21981 27.2069 4.95808V15.3323C27.2069 18.0706 24.9871 20.2904 22.2489 20.2904H4.95846C2.22019 20.2904 0.000384623 18.0706 0.000384623 15.3323V6.93472C-0.000127111 6.91219 -0.000129304 6.88961 0.000384623 6.86699Z"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.5582f29a.svg";
export { ForwardRef as ReactComponent };